module.exports = __webpack_public_path__ + "img/industry-banner-03.97cbc0f9.png";